import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { actionTypes, useStateValue } from "../../store";
import Header from "../HIValuePlus/BaseComponents/Header";
import HIFotterMain from "../HIValuePlus/BaseComponents/Footer";
import {
  getCustomerOrderList,
  GetSellProductByCustomer,
} from "../../networkCalls";
import LoadingCellFullPage from "../LoadingCell/LoadingCellFullPage";
import { Pagination, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ViewRequestIcon } from "../HIValuePlus/BaseComponents/icon";
const MySellProducts = () => {
  const [{ token, huid }, dispatch] = useStateValue();
  const [loading, setLoading] = useState(false);
  const [orderlistData, setOrderlistData] = useState([]);

  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = useState(1);

  const checkOrderListData = () => {
    var data = new FormData();
    data.append("customerId", huid);
    // data.append("XAuth", token);
    data.append("page", page);
    setLoading(true);
    GetSellProductByCustomer(data).then((res) => {
      console.log("data is", res.data);
      setLoading(false);
      switch (res.data.status) {
        case 1:
          setPageCount(res?.data?.products?.pagination);
          setOrderlistData(res?.data?.products?.list);

          return true;
        case 0:
          break;
        case 2:
          dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
          break;
        default:
          return;
      }
    });
  };
  useEffect(() => {
    checkOrderListData();
  }, [token, huid, dispatch, page]);
  const handleChange = (event, value) => {
    setPage(value);
  };
  return (
    <>
      <Header />
      {loading ? (
        <>
          <LoadingCellFullPage />
        </>
      ) : (
        <>
          <div className="innerpagebg pt-5 pb-5">
            <div className="container">
              <div className="row">
                <div className="col-9 text-left m-auto">
                  <div className="d-flex justify-content-center align-items-center">
                    <h4 className=" text-center m-0 fw-bold text-uppercase">
                      <span className="texthivalueplus">My </span>{" "}
                      <span className="txtdgray">
                        Products ({orderlistData?.length})
                      </span>
                    </h4>
                    {orderlistData.length > 0 && (
                      <div className="ms-auto">
                        <Link
                          to="/myaccount/add-product"
                          className="d-block mt-3 f18 fw-bold"
                        >
                          + ADD NEW PRODUCT
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="container mt-3">
              <div className="row">
                <div className="col-lg-9 col-md-12 col-12 m-auto">
                  {orderlistData.length > 0 &&
                    <div className="table-responsive mt-4">
                      <table className="table table-bordered table-striped">
                        <thead className="">
                          <tr>
                            <th>Model Name</th>
                            <th>Year of Purchase</th>
                            <th>Warranty Expiry Date</th>
                            <th>View Details</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderlistData.map((val, id) => {
                            return (
                              <tr key={id} className="f13 ">
                                <td className="txtred fw500">
                                  {val.productName}
                                </td>
                                <td>{val.yearOfManufacture}</td>
                                <td>{val.warranty}</td>
                                <td className=" d-flex gap-2 align-items-center">
                                 <Tooltip title="View Details" placement="left" arrow>

                                  <Link
                                    to={`/myaccount/sell-your-product/product-details/${val.sellingId}`}
                                    className="text-black"
                                  >
                                  {/* View Details | */}
                                    <VisibilityIcon color="black"/>{" "}
                                  </Link>
                                 </Tooltip>
                                  <Tooltip title="View Request" placement="right" arrow>

                                  <Link
                                    to={`/myaccount/sell-your-product/request/${val.sellingId}`}
                                  >
                                    {/* View Request */}
                                    <ViewRequestIcon/>
                                  </Link>
                                  </Tooltip>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  }
                  {orderlistData && orderlistData?.length <= 0 ? (
                    <>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className=" text-center p-4">
                            No Product Listed Yet.
                          </div>
                          <div className="d-flex justify-content-center align-items-center">
                            <Link
                              to="/myaccount/add-product"
                              className="d-block  fw-bold text-center border rounded p-3 w-25 fw-semibold f16 txtdgray  "
                            >
                              Add Product
                            </Link>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                {orderlistData?.length > 0 && <div className="col-lg-9 col-md-12 col-12 d-flex justify-content-center m-auto">
                  <Pagination
                    color="error"
                    variant="outlined"
                    // shape="rounded"
                    count={pageCount}
                    page={page}
                    onChange={handleChange}
                    sx={{
                      "& .MuiPaginationItem-root": {
                        color: "#0873bb", // text color for unselected
                        borderColor: "#0873bb", // border for outlined variant
                        "&:hover": {
                          backgroundColor: "rgba(8, 115, 187, 0.1)", // light blue hover
                        },
                      },
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: "#0873bb", // ✅ your base color for active background
                        color: "#fff", // white text
                        borderColor: "#0873bb",
                        "&:hover": {
                          backgroundColor: "#065f99", // slightly darker on hover
                          borderColor: "#065f99",
                        },
                      },
                    }}
                  />
                </div>}
              </div>
            </div>
          </div>
        </>
      )}
      <HIFotterMain />
    </>
  );
};

export default MySellProducts;
